export default __webpack_public_path__ + "static/media/northern_lights2.cbc9401b.jpg";